import {
  useCallback,
  useEffect,
  useState,
} from 'react';

// the folders open in the sidebar: a local setting, never synced
const KEY = 'expandedFolders';

// storage can be off, or throw, in a private window
const saved = (): string[] => {
  try {
    const ids: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(ids) ? ids.filter(id => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

const save = (ids: string[]) => {
  try {
    if (ids.length) localStorage.setItem(KEY, JSON.stringify(ids));
    else localStorage.removeItem(KEY);
  } catch {}
};

// which folders are open, and a way to open or close one
export const useExpandedFolders = () => {
  const [expanded, setExpanded] = useState(saved);
  useEffect(() => save(expanded), [expanded]);
  const setOpen = useCallback(
    (id: string, open: boolean) =>
      setExpanded(ids => [
        ...ids.filter(i => i !== id),
        ...(open ? [id] : []),
      ]),
    [],
  );
  return [expanded, setOpen] as const;
};
